import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { AdminUser } from "@/integrations/supabase/user-types";

const ADMIN_USERS_QUERY_KEY = ['admin-users'];

export const useAdminUsers = (includeDeleted: boolean = false) => {
  const queryClient = useQueryClient();

  const invalidateUsers = () => {
    return queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY });
  };

  const query = useQuery({
    queryKey: [ADMIN_USERS_QUERY_KEY, includeDeleted],
    queryFn: async () => {
      console.log('Fetching users...');
      const { data, error } = await supabase
        .rpc('get_admin_users_summary', { include_deleted: includeDeleted });

      if (error) {
        console.error('Error fetching users:', error);
        throw error;
      }

      console.log('Users fetched:', data);
      return data as AdminUser[];
    }
  });

  const deleteUser = async (userId: string) => {
    try {
      const { error } = await supabase
        .from('profiles')
        .delete()
        .eq('id', userId);

      if (error) throw error;
      
      await invalidateUsers();
      return { success: true };
    } catch (err) {
      console.error('Error deleting user:', err);
      throw err;
    }
  };

  return {
    users: query.data,
    loading: query.isLoading,
    error: query.error?.message || null,
    deleteUser,
    refreshUsers: invalidateUsers
  };
};